import { render, staticRenderFns } from "./ProfessionalCard.vue?vue&type=template&id=d98af8c0&"
import script from "./ProfessionalCard.vue?vue&type=script&lang=js&"
export * from "./ProfessionalCard.vue?vue&type=script&lang=js&"
import style0 from "./ProfessionalCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports